<template>
  <div class="landingpage">
    <div class="navbar">
            <img src="@/assets/inandout.png" class="logo-text"/>
            <button class="land-btn">Sign Up</button>
    </div>

    <div class="main-area">
    <div class="fullscreen-img-wrap"
    :style="{'background-image': 'url(' + displayed_image + ')'}">
    </div>
    <div class="overlay"></div>
    <div class="over-content">
      <p class="over-content-title">ANYBODY CAN GET IT<br />
      </p>
      <img src="@/assets/Nba2k20_logo.png"  />
      <div>
        <br />
        <div class="newsletterform" v-if="!feedback || feedtype == 'danger'">
            <label>Signup today to be apart of the racing experience!</label>
            <br />
            <p class="text-danger warning-error">{{feedback}}</p>
            <input type="email" class="email-form" placeholder="Email" v-model="email" required/>
            <button class="land-btn" @click="sendEmail()">Join Today</button>
        </div>
        <div class="newsletterform feedback" v-if="feedback && feedtype != 'danger'">
          <p>{{feedback}}</p>
        </div>

        <br /><br />
        <div>
          <b-button v-b-modal.modal-1 variant="danger">Show Schedule</b-button>

          <b-modal id="modal-1" size="xl" title="BootstrapVue" hide-header hide-footer>
            <img src="@/assets/main/main_3.png" class="model-img"  />
          </b-modal>
        </div>
      </div>
      <!-- <div class="mainimage-section">
        <span class="mainimage displayed"></span>
        <span class="mainimage"></span>
        <span class="mainimage"></span>
      </div> -->
    </div>
  </div>
  <div id="WHEREDONK" class="wrapper">
    <div class="container">
      <div class="row">
      <div class="text-content col-lg-6">
        <h2>WHERE'S DONKMASTER?</h2>
        <p>Can't wait for the app to come out?</p>
        <br />
        <p>Come be apart of our exclusive
        beta testing group to try out our
        new racing app. </p>
        <br />
        <p>Please sign up with your email above!
        We are only accepting the first 500
        applicants!</p>
        <br />
        <button class="land-btn">JOIN TODAY</button>
      </div>
      <div class="apptemplates col-lg-6">
        <div class="apptemplatescroll nonMobile">
          <img
          v-for="(apt, idx) in apptemplates"
          :key="idx"
          :src="apt" :class="{'focusedimage': idx == 1}"/>
        </div>
        <div class="apptemplatescroll isMobile">
          <img
          v-for="(apt, idx) in apptemplates"
          :key="idx"
          :src="apt"/>
        </div>
        <div class="apptemplate-controls">
          <p class="appimg-pag">
            <span>1 2 3</span>
          </p>
            <img src="@/assets/svg/wheel.svg" @click.prevent="switchImg()" class="wheel" />
        </div>
      </div>
    </div>
  </div>
  </div>
  <div class="footer">
          <p class="text-center">2020 © 2k20 Tours | All Rights Reserved</p>
  </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'landingpage',
  data(){
    return{
      feedback:'',
      feedtype:'',
      email:'',
      error: '',
      displayed_image: '',
      hero_image:[
        require('@/assets/main/main_1.jpg'),
        require('@/assets/main/main_2.jpg'),
        require('@/assets/main/main_3.png'),
      ],
      apptemplates:[
        require('@/assets/app_templates/apptemplate1.png'),
        require('@/assets/app_templates/apptemplate3.png'),
        require('@/assets/app_templates/apptemplate2.png'),
      ]
    }
  },
  methods:{
    switchImg(){
      this.apptemplates[1] = require('@/assets/app_templates/apptemplate1.png')
    },
    sendEmail(){
      if(!this.email){
        this.feedback= "You must enter a valid email!"
        this.feedtype= "danger"
      }else{
        if(this.email.includes('@') && this.email.includes('.')){
          axios.post('https://tycooperaow.pythonanywhere.com/racewaybets/newsletter', {
            email: this.email.toLowerCase()
          }).then((res)=>{
              this.feedback=res.data.feedback
              this.feedtype=res.data.feedtype
              // alert(res.data.dull_list)
          }).catch((err) => {
            this.error = err
          })
        }else{
          this.feedback = "You must enter a valid email!"
          this.feedtype= "danger"
        }
      }
    }
  },
  mounted(){
    let num_count = 0
    this.displayed_image = this.hero_image[num_count]
    setInterval(() =>{
      if(num_count > 2){
        num_count = 0
        this.displayed_image = this.hero_image[num_count]
      }else{
        this.displayed_image = this.hero_image[num_count]
        num_count++
      }
    }, 3000);
  }

}
</script>
<style scoped>
h3{
  text-align: center;
}
a {
  color:#fff;
  text-decoration: none;
}

a:hover{
  text-decoration: none;
}

.navbar{
  width: 100%;
  background-color: transparent;
  z-index: 10;
  position: fixed;
  top:0;
  left: 0;
  width: 100%;
  color: #fff
}
.main-area{
  margin-top: -4.5rem;
  position: relative;
}
.email-form{
  padding: .6rem 1rem;
  border-radius: 10px;
}
.land-btn{
  padding: .5rem 1.6rem;
  border: none;
  background-color: #FF0000;
  text-transform: uppercase;
  color: #fff;
  border-radius: 8px;
}
.fullscreen-img-wrap {
  width: 100%;
  height: 100vh;
  overflow:hidden;
  /* Set a specific height */
  min-height: 500px;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.overlay{
  overflow-x: hidden;
  max-width: 100vw;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #111;
  opacity: 0.4;
  z-index: 2;
}
.over-content{
  z-index: 2;
  top: 30%;
  width: 100%;
  position: absolute;
  color:#fff;
  font-size: 20px;
  font-weight: bold;
  color:#fff;
  text-align: center;
}
.over-content img{
  width: 32rem;
}
.over-content p{
  color: #FF0000;
  font-weight: 400;
  text-transform: uppercase;
  -webkit-font-family: Bahnschrift;
  font-family: Bahnschrift;

}
.over-content label{
  color: #FF0000;
  font-size: 30px;
  font-weight: 100;
  -webkit-font-family: Arial, Helvetica, sans-serif;
  font-family: Arial, Helvetica, sans-serif;
}
.over-content-title{
  -webkit-font-family: Arial, Helvetica, sans-serif;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 2rem;
  position: relative;
}
.model-img{
  width: 100%;
}
.mainimage-section{
  text-align: center;
  position: relative;
  margin-top:5rem;
}
.mainimage{
  border-radius: 100%;
  border: 4px solid #fff;
  padding: .5rem 1rem;
  margin: .5rem;
  transition: .4s;
}
.mainimage:hover{
  background-color: #fff;
}
.feedback p{
  font-size: 30px;
  color: #adebad;
}
#WHEREDONK{
  height: 100vh;
  background: #000;
  padding-top: 4rem;
}
#WHEREDONK h2{
  color: #FF0000;
  /* -webkit-font-family: Bahnschrift;
  font-family: Bahnschrift; */
  -webkit-font-family: Arial, Helvetica, sans-serif;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 38px;
}
#WHEREDONK p{
  color: #fff;
  -webkit-font-family: Arial, Helvetica, sans-serif;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 26px;
}
#WHEREDONK .apptemplates{
  text-align: center;
}
#WHEREDONK .wheel{
  width: 9rem;
  background:transparent;
  border: none;
  transition: .3s;
}
#WHEREDONK .wheel:hover{
  transform: rotate(90deg);
  cursor:pointer;
}
.apptemplatescroll img{
  width: 6rem;
  transition: 1s;
}
.apptemplatescroll .focusedimage{
  width: 12rem;
}
.appimg-pag{
  margin-top: 1rem;
}
.footer{
  color:#fff;
  background-color: #000;
  padding-bottom: 3rem;
}
.isMobile{
  display: none;
}
/* for mobile */
@media only screen and (max-width: 540px) {
  .nonMobile{
    display: none;
  }
  .over-content{
    -webkit-font-family: Arial, Helvetica, sans-serif;
    font-family: Arial, Helvetica, sans-serif;
  }
  h2{
    -webkit-font-family: Arial, Helvetica, sans-serif;
    font-family: Arial, Helvetica, sans-serif;
  }
  .over-content img{
    width: 18rem;
  }
  .over-content label{
    font-size: 18px;
  }
  #WHEREDONK{
    text-align: center;
  }
  #WHEREDONK h2{
    -webkit-font-family: Arial, Helvetica, sans-serif;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 30px;
  }
  #WHEREDONK .wheel{
    width: 6rem;
    background:transparent;
    border: none;
    transition: .3s;
  }
  #WHEREDONK .wheel:hover{
    transform: rotate(90deg);
    cursor:pointer;
  }
  .isMobile{
    margin-top: 5rem;
    margin-bottom: 5rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 2fr;
    grid-column-gap: 2px;
    grid-row-gap: 20px;
    justify-items: stretch;
    align-items: stretch;
  }
  .apptemplatescroll img{
    width: 6rem;
    transition: 1s;
  }
  .footer{
    padding-top: 36rem;
  }
}
@media only screen and (max-width: 950px) {
}
</style>
